// @ts-check

/**
 * @typedef {Object} USER_ADDRESS_TYPE
 * @property {string} ID
 * @property {string} TYPE
 * @property {string} STREET
 * @property {string} CITY
 * @property {string} PROVINCE
 * @property {string} COUNTRY
 * @property {string} POSTAL_CODE
 * @property {string} PLACE_ID
 * @property {string} LAT
 * @property {string} LNG
 * @property {string} UNIT
 */

/**
 * @readonly
 * @type {USER_ADDRESS_TYPE}
 */
const USER_ADDRESS = Object.freeze({
	ID: 'address_id',
	TYPE: 'type',
	STREET: 'street',
	CITY: 'city',
	PROVINCE: 'province',
	COUNTRY: 'country',
	POSTAL_CODE: 'postalCode',
	PLACE_ID: 'placeId',
	LAT: 'lat',
	LNG: 'lng',
	UNIT: 'unit',
});

export default USER_ADDRESS;
